{
    "no_product_found": "Aucun produit sélectionné",
    "add_product": "Ajouter",
    "toast__product_added_title": "Article ajouté",
    "toast__product_added_body": "{{quantity}} {{unit}} ajouté(s) au brouillon",
    "iframe_title": "Catalogue produits"
}
